export enum LogModuleEnum {
    USER = 'User',
    SALES_ORDER = 'Sales Order',
    DELIVERY_ORDER = 'Delivery Order',
    CHALLAN = 'Challan',
}
